export default __webpack_public_path__ + "static/media/Employees_Falls Efficacy Scale.645114e7.pdf";